export default __webpack_public_path__ + "static/media/8ce6acdd035b415b33f5b3786c5cd3d7.d975fd12.png";